import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import CartItems from '@/components/CartItems'
import CartOrderSummary from '@/components/CartOrderSummary'
import CartProgressHeader from '@/components/CartProgressHeader'
import RelatedAssets from '@/components/RelatedAssets'

import BeginCheckoutButton from './BeginCheckoutButton'
import CartHeader from './CartHeader'

const Cart = () => {
  const itemCount = useSelector(state => state.cart.itemsTotalCount)
  const storeCurrency = useSelector(state => state.currentRegion.storeCurrency)

  return (
    <section className='cart'>
      <div className='cart-progress-header u-push-half--bottom'>
        <CartHeader />
        <CartProgressHeader cartStepNumber={1} />
      </div>

      <div className='order-summary-row'>
        <div className='order-summary-products'>
          <div className='order-summary__header'>
            <h2
              className='order-summary__heading styled_as_body_font'
              id='cart-items-count'
              tabIndex='-1'
            >
              <FormattedMessage
                id='carts.your_items_count'
                values={{ count: itemCount }}
              />
            </h2>
            <div className='u-align--right u-weight--medium u-soft-half--right'>
              {storeCurrency}
            </div>
          </div>
          <div className='order-summary__body'>
            <CartItems />
          </div>
          <RelatedAssets />
        </div>

        <div className='order-summary-total u-soft-md-twice--top'>
          <CartOrderSummary />
          <BeginCheckoutButton isDisplayContinueShoppingLink />
        </div>
      </div>
    </section>
  )
}

export default Cart
